import React, { useContext, useEffect } from 'react';
import * as Oidc from 'oidc-client';
import { PrivateContext } from './IdentityProvider';
export default function OidcSilentCallback() {
    const { privateState, privateDispatch } = useContext(PrivateContext);
    useEffect(() => {
        if (!privateDispatch)
            return;
        new Oidc.UserManager({}).signinSilentCallback()
            .catch(error => {
            console.log(`Unable to complete authentication from OpenID Connect: ${error}`);
            privateDispatch({ type: 'BEGIN_REDIRECT', redirectTarget: '/' });
        })
            .finally(() => {
            window.location.hash = '';
        });
    }, [privateDispatch]);
    if (privateState.debugMode === true) {
        return React.createElement("h1", null, "Processing response from Identity Server");
    }
    return null;
}
